import type { BaseCrossSectionFilterType } from '@/stores/type/crossSectionFilter.type'
import { defineStore } from 'pinia'

const initialBaseCrossSectionFilterSet: BaseCrossSectionFilterType = {
  calculation: null,
  calculation_method: null,
  calculation_type: null,
  order_by: null,
  favorite: null
}

function hasActiveFilters(
  filters: Record<string, any>,
  initFilters: Record<string, any>,
  keys: string[]
): boolean {
  return keys.some((key) => {
    return filters[key] !== initFilters[key]
  })
}

export const useCrossSectionFilterStore = defineStore({
  id: 'crossSectionFilter',
  state: () => ({
    initBaseCrossSectionFilterSet: { ...initialBaseCrossSectionFilterSet },
    baseCrossSectionFilterSet: { ...initialBaseCrossSectionFilterSet }
  }),
  actions: {
    resetAll() {
      this.initBaseCrossSectionFilterSet = { ...initialBaseCrossSectionFilterSet }
      this.baseCrossSectionFilterSet = { ...initialBaseCrossSectionFilterSet }
    },
    clearAllFilter(): void {
      const orderBy = this.baseCrossSectionFilterSet.order_by
      this.baseCrossSectionFilterSet = { ...this.initBaseCrossSectionFilterSet }
      this.baseCrossSectionFilterSet.order_by = orderBy
    }
  },
  getters: {
    activeCalculationMethodFilters(state): boolean {
      return hasActiveFilters(
        state.baseCrossSectionFilterSet,
        state.initBaseCrossSectionFilterSet,
        ['calculation_method']
      )
    },
    activeCalculationTypeFilters(state): boolean {
      return hasActiveFilters(
        state.baseCrossSectionFilterSet,
        state.initBaseCrossSectionFilterSet,
        ['calculation_type']
      )
    },
    activeFavoriteFilters(state): boolean {
      return hasActiveFilters(
        state.baseCrossSectionFilterSet,
        state.initBaseCrossSectionFilterSet,
        ['favorite']
      )
    },
    activeFiltersCount(): number {
      const getters = [
        this.activeCalculationMethodFilters,
        this.activeCalculationTypeFilters,
        this.activeFavoriteFilters
      ]
      return getters.reduce((count, getter) => {
        return count + (getter ? 1 : 0)
      }, 0)
    }
  }
})
